import type { PaginationProps, TableProps } from 'antd';
// import { Table as AntTable } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Table as AntTable } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { $background, $primary, $secondary } from '../../styles/Variables';

const StyledTable = styled(AntTable)`
  td.ant-table-cell {
    /* padding: 6px 12px !important; */
  }
  .ant-table-tbody > tr > td {
    /* padding: 8px 12px; */
  }

  .ant-table-cell {
    :has(.nested-table) {
      border-bottom: 1px solid #000;
    }
  }

  &.ant-table-wrapper .ant-table-thead > tr > th {
    padding: 12px 16px;
    background-color: #f9fafb;
    color: var(--color-light-grey);
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }

  &.ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 4px 12px;
    background-color: #fff;
  }

  &.ant-table-wrapper tr.ant-table-expanded-row > td {
    padding: 16px 12px;
    border-bottom: 1px solid #a2a1a1;
    /* background-color: #fff !important; */
  }

  &.ant-table-wrapper .ant-table-pagination.ant-pagination {
    .ant-pagination-prev {
      margin-right: auto;
    }

    .ant-pagination-next {
      margin-left: auto;
    }

    .arrow {
      margin: 0 8px;
      color: var(--color-light-grey);
    }

    .anticon {
      color: var(--color-light-grey);
    }
  }

  .ant-pagination {
    .ant-pagination-item {
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-weight: 500;
      border: none;

      a {
        color: var(--color-light-grey);
      }
    }

    .ant-pagination-item-active {
      background-color: #f9fafb;
      width: 40px;
      height: 40px;
      line-height: 40px;
      border: none;
      border-radius: 8px;
      font-weight: 500;

      a {
        color: #1d2939;
      }
    }
  }

  .drop-over-downward td {
    border-bottom: 2px dashed #1890ff !important;
  }

  .drop-over-upward td {
    border-top: 2px dashed #1890ff !important;
  }

  .ant-table-row.dragging {
    opacity: 0.5;
  }

  /* .ant-pagination .ant-pagination-item-active {
    background-color: #f9fafb;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: none;

    a {
      color: #1d2939;
    }
  } */

  /* .ant-table-row {
    &.approved {
      > td.ant-table-cell {
        color: #dbdbdb;
      }
    }
  }

  .ant-table-thead > tr > th {
    color: ${$secondary};
    background: ${$primary};
  }

  .ant-table-tbody > tr > td {
    color: ${$primary};
  }

  .ant-table-tbody > tr:nth-of-type(odd) {
    background: ${$background};
  }

  #components-table-demo-drag-sorting tr.drop-over-downward td {
    border-bottom: 2px dashed #1890ff;
  }

  #components-table-demo-drag-sorting tr.drop-over-upward td {
    border-top: 2px dashed #1890ff;
  } */
`;

export const Table = (props: TableProps<Record<string, any>>) => {
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement
  ) => {
    if (type === 'prev') {
      return (
        <>
          <ArrowLeftOutlined size={20} />
          <span className="arrow">Previous</span>
        </>
      );
    }
    if (type === 'next') {
      return (
        <>
          <span className="arrow">Next</span>
          <ArrowRightOutlined size={20} />
        </>
      );
    }
    return originalElement;
  };

  return (
    <StyledTable
      {...props}
      pagination={
        props.pagination ? { ...props.pagination, itemRender } : false
      }
    >
      {props?.children as ReactNode}
    </StyledTable>
  );
};

export default Table;
